
import React from "react";
import Select, { components } from "react-select";

const LIMIT = 10;

const LimitedMenuList = (props) => {
  const childrenArray = React.Children.toArray(props.children);

  return (
    <components.MenuList {...props}>
      {childrenArray.slice(0, LIMIT)}
    </components.MenuList>
  );
};

const Filters = ({search,setSearch,category,setCategory,categories}) => {
  const categoryOptions = [
  { value: "", label: "All Categories" },
  ...categories.map((cat) => ({
    value: cat.id,
    label: cat.name,
  })),
];
  return (
<div className="flex flex-col md:flex-row items-center gap-4 p-6 bg-white rounded-2xl border border-gray-200 shadow-sm mb-6">
  <div className="relative flex-1 w-full">
    <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>

    <input
      type="text"
      placeholder="Search videos, categories, or keywords..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  <div className="flex flex-col md:flex-row items-center gap-3 w-full md:w-auto">
    <div className="w-full md:max-w-[250px] md:min-w-[200px]">
      <Select
        options={categoryOptions}
        isSearchable
        classNamePrefix="filter"
        components={{ MenuList: LimitedMenuList }}
        value={categoryOptions.find(opt => opt.value === category) || null}
        onChange={(selected) => setCategory(selected?.value || "")}
        placeholder="Search category..."
        styles={{
          control: (base) => ({
            ...base,
            padding: "8px 12px",
            borderRadius: "12px",
            borderColor: "#D1D5DB",
            "&:hover": { borderColor: "#9CA3AF" }
          }),
          placeholder: (base) => ({ ...base, color: "#6B7280" })
        }}
      />
    </div>
  </div>
</div>


  )
}

export default Filters
